// Photorealistic Melbi vial. Renders the AI-generated product photo.
// Files live in /app/frontend/public/vials/{slug}.{webp|png}
// Serves WebP (~90% smaller) with PNG fallback for older browsers.
import React from "react";

// Slugs whose product photos should render without a drop-shadow (user request: no shadow below these products)
const NO_SHADOW_SLUGS = new Set(["skin-care", "nad-nasal-spray", "glutathione-nasal-spray"]);

export default function MelbiVial({
  slug,
  alt,
  className = "",
  testId,
  eager = false,
}) {
  const finalClassName = NO_SHADOW_SLUGS.has(slug)
    ? className.replace(/\bvial-shadow\b/g, "").replace(/\s+/g, " ").trim()
    : className;
  return (
    <picture style={{ display: "contents" }}>
      <source srcSet={`/vials/${slug}.webp`} type="image/webp" />
      <img
        src={`/vials/${slug}.png`}
        alt={alt || `Melbi ${slug} vial`}
        data-testid={testId}
        className={finalClassName}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={eager ? "high" : "auto"}
        draggable={false}
      />
    </picture>
  );
}
